export default __webpack_public_path__ + "775a5a8d67c2e7bab5fb11d0310b897a.svg";